import { render, staticRenderFns } from "./CollectedPayment.vue?vue&type=template&id=fda80650"
import script from "./CollectedPayment.vue?vue&type=script&lang=js"
export * from "./CollectedPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports